import { Box } from "@mui/material"
import React, { useEffect, useState } from "react"
import "./BadgeContent.css"
import Ssig from "./../../../static/AS-sig.png";
import ASsig from "./../../../static/sig-rajbeers.png";
import QRCode from "react-qr-code";
import { trackPromise } from "react-promise-tracker";
import axios from "axios";
import { AUTHORIZATION, HOSTNAME } from "../../../common/constants";
import authTokenForAPI from "../../../utils/authTokenForAPI";
import { isAPISuccess } from "../../../utils/commonUtils";
import { centrePrefix, deptList } from "../badgeUtils";


const BadgeContent = ({ details, photoBadge }) => {
    const [photo, setPhoto] = useState("");
    const [relationString, setRelationString] = useState("")
    const [snack, setSnack] = useState({
        open: false,
        severity: "success",
        msg: "",
    });
    useEffect(() => {
        if (details.id) {
            trackPromise(
                axios
                    .get(
                        `${HOSTNAME}/sewadars/${details.id}/image`,
                        {
                            headers: { [AUTHORIZATION]: authTokenForAPI() },
                            responseType: "blob"
                        }
                    )
                    .then((res) => {
                        if (isAPISuccess(res.status)) {
                            console.log(res)
                            // setPhoto(res.data);
                            const url = URL.createObjectURL(res.data);
                            setPhoto(url);
                        } else {
                            setPhoto({});

                        }
                    })
                    .catch(() => {
                        setPhoto({});

                    })
            );
            if (String(details.gender).toUpperCase() === "M")
                setRelationString("S/o.");
            else if (String(details.maritalStatus).trim().toUpperCase() === "MARRIED")
                setRelationString("W/o.")
            else setRelationString("D/o.")
        }

    }, [details])


    return (
        <Box className="badge-content">
            {photoBadge ? <>
                <Box className="badge-id" >
                    <span style={{ fontSize: "15px", fontWeight: "700" }}>ID No.- </span>
                    <span style={{ fontSize: "16px", fontWeight: "800" }}>{centrePrefix[details.subCentre]}</span>
                    {details.id}
                </Box>
                <Box className="badge-photo"><img src={photo} alt="Sewadar photo" height={"96px"} width={"80px"} /></Box>
                <Box className="badge-name" style={{ fontSize: details.name?.length > 17 ? '14px' : 'inherit' }}>{details.name}</Box>
                <Box className="badge-rel" fontSize={"10px"}>{relationString} {details.relativeName}</Box>
                <Box className="badge-qr">
                    <QRCode value={String(details.id)} size={60} />
                </Box>
            </> :
                <>
                    <Box className="badge-id-noPhoto">
                        <div style={{ fontSize: "25px", fontWeight: "700" }}>ID No.</div>
                        <span style={{ fontSize: "28px", fontWeight: "800" }}>{centrePrefix[details.subCentre]}</span>
                        {details.id}
                    </Box>
                    <Box className="badge-name-noPhoto" style={{ fontSize: details.name?.length > 17 ? '14px' : 'inherit' }}>{details.name}</Box>
                    <Box className="badge-rel-noPhoto">{relationString} {details.relativeName}</Box>
                    <Box className="badge-qr-noPhoto" marginBottom={"5px"}>
                        <QRCode value={String(details.id)} size={75} />
                    </Box>
                </>}
            <Box className="badge-details">
                <Box>
                    <Box>Sewa at M.C.-</Box>
                    {!photoBadge && <Box>Contact No.-</Box>}
                    <Box>Emergency No.-</Box>
                    <Box>Blood Group-</Box>
                </Box>
                <Box>
                    <Box fontWeight={800} style={{ fontSize: details.zoneDepartment?.length > 10 ? '7.5px' : 'inherit' }}>{deptList[details.zoneDepartment] ? deptList[details.zoneDepartment] : (details.zoneDepartment || "_")}</Box>
                    {!photoBadge && <Box>{details.mobileNumber || "_"}</Box>}
                    <Box>{details.emergencyNumber || "_"}</Box>
                    <Box>{details.bloodGroup || "_"}</Box>
                </Box>
                {details.subCentre === "SAHARANPUR-I" ? <Box className="badge-sig">
                    <Box><img src={Ssig} alt="" height={"14px"} /></Box>
                    <Box>anil sadana</Box>
                    <Box>( secretary )</Box>
                </Box> :
                    <Box className="badge-sig">
                        <Box><img src={ASsig} alt="" height={"14px"} /></Box>
                        <Box>rajbeer singh</Box>
                        <Box>(area secretary)</Box>
                    </Box>}
            </Box>

        </Box>)
}

export default BadgeContent;